import { gql, useMutation } from '@apollo/client'
export const USER_SENTENCES_QUERY = gql`
  query AllUserSentencesWithTranslations($username: String!, $lang: String!, $relationships: [String!]!) {
    allUserSentencesWithTranslations(username: $username, lang: $lang, relationships: $relationships) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`

export const ADD_USER_SENTENCE_MUTATION = gql`
  mutation AddUserSentence(
    $sourceText: String!
    $targetText: String!
    $sourceLang: String!
    $targetLang: String!
    $tags: [String]!
    $username: String!
    $sharedWith: [String]!
  ) {
    AddUserSentence(
      sourceText: $sourceText
      targetText: $targetText
      sourceLang: $sourceLang
      targetLang: $targetLang
      tags: $tags
      username: $username
      sharedWith: $sharedWith
    ) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`

export const USER_SENTENCES_WITH_TRANSLATIONS_QUERY = gql`
  query UserSentencesWithTranslations($username: String!, $lang: String!, $translationLang: String!) {
    userSentencesWithTranslations(username: $username, lang: $lang, translationLang: $translationLang) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`
export const SHARED_SENTENCES_WITH_TRANSLATIONS_QUERY = gql`
  query SharedSentencesWithTranslations($username: String!, $lang: String!, $translationLang: String!) {
    sharedSentencesWithTranslations(username: $username, lang: $lang, translationLang: $translationLang) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`;
export const TATOEBA_SENTENCES_QUERY = gql`
  query SentenceWithTranslations($lang: String!, $word: String!, $translationLang: String!) {
    SentenceWithTranslations(lang: $lang, word: $word, translationLang: $translationLang) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`
export const GET_ALL_TRANSLATION_USER_SENTENCES = gql`
  query AllTranslationUserSentences($username: String!, $sourceLang: String) {
    allTranslationUserSentences(username: $username, sourceLang: $sourceLang) {
      sentence {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
      translations {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
    }
  }
`
export const FLASHCARD_SENTENCES_QUERY = gql`
  query FlashcardSentences($username: String!, $sourceLang: String, $targetLang: String, $tags: [String]) {
    flashcardSentences(username: $username, sourceLang: $sourceLang, targetLang: $targetLang, tags: $tags) {
      sentence {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
        imageUrl
        imageDescription
      }
      translations {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
        imageUrl
        imageDescription
      }
    }
  }
`

// Record a mnemonic-image URL for a Word, keyed by (text, lang, username).
// Bytes are NOT sent through GraphQL — the frontend uploads to the image
// server first and only passes the resulting public URL here. This keeps the
// Render-hosted GraphQL server free of byte storage (its disk is ephemeral).
export const SET_WORD_IMAGE_MUTATION = gql`
  mutation SetWordImage($text: String!, $lang: String!, $username: String!, $imageUrl: String!, $description: String) {
    setWordImage(text: $text, lang: $lang, username: $username, imageUrl: $imageUrl, description: $description) {
      id
      text
      lang
      imageUrl
      imageDescription
      imageGeneratedAt
    }
  }
`

export const REMOVE_WORD_IMAGE_MUTATION = gql`
  mutation RemoveWordImage($text: String!, $lang: String!, $username: String!) {
    removeWordImage(text: $text, lang: $lang, username: $username) {
      id
      text
      lang
      imageUrl
    }
  }
`
export const GET_ALL_TRANSLATION_SHARED_SENTENCES = gql`
  query AllSharedSentencesWithTranslations($username: String!, $sourceLang: String) {
    allSharedSentencesWithTranslations(username: $username, sourceLang: $sourceLang) {
      sentence {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
      translations {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
    }
  }
`
export const TATOEBA_SENTENCES_ALL_TRANSLATIONS_QUERY = gql`
  query SentenceWithAllTranslations($lang: String!, $word: String!) {
    SentenceWithAllTranslations(lang: $lang, word: $word) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`
export const GET_INSPIRATIONS_QUERY = gql`
  query GetInspirations($username: String!) {
    getInspirations(username: $username) {
      identity
      labels
      properties {
        text
        lang
        username
      }
      elementId
    }
  }
`
export const SAVE_SENTENCE_MUTATION = gql`
  mutation SaveSentence($username: String!, $sentenceId: ID!) {
    SaveSentence(username: $username, sentenceId: $sentenceId) {
      id
      text
      lang
    }
  }
`
export const CHECK_SAVED_STATUS_QUERY = gql`
  query CheckSavedStatus($username: String!, $sourceSentenceId: ID!, $translationSentenceId: ID!) {
    checkSavedStatus(username: $username, sourceSentenceId: $sourceSentenceId, translationSentenceId: $translationSentenceId) {
      sourceSaved
      translationSaved
    }
  }
`
export const SAVE_SENTENCES_MUTATION = gql`
  mutation SaveSentences($username: String!, $sourceSentenceId: ID!, $translationSentenceId: ID!) {
    saveSentences(username: $username, sourceSentenceId: $sourceSentenceId, translationSentenceId: $translationSentenceId) {
      sourceSentence {
        id
      }
      sourceSaved
      translationSentence {
        id
      }
      translationSaved
    }
  }
`
export const LOGIN_MUTATION = gql`
  mutation Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
      user {
        id
        username
      }
    }
  }
`;
export const REGISTER_MUTATION = gql`
  mutation Register($username: String!, $password: String!) {
    register(username: $username, password: $password) {
      id
      username
    }
  }
`;
export const GET_PROJECTS_QUERY = gql`
  query GetProjects($username: String!) {
    getProjects(username: $username) {
      identity
      labels
      properties {
        title
        username
      }
      elementId
    }
  }
`;
export const GET_TASKS_BY_PROJECT_QUERY = gql`
  query GetTasksByProject($projectName: String!) {
    getTasksByProject(projectName: $projectName) {
      task {
        identity
        labels
        properties {
          title
          type
          description
          priority
          assignee
          timeBudget
          timeSpent
          dueDate
          dateAdded
          dateLastModified
          username
          project
        }
        elementId
        assignedTo {
          identity
          properties {
            username
          }
        }
      }
      status
    }
  }
`;
export const GET_TASKS_QUERY = gql`
query GetTasks($username: String!) {
  getTasks(username: $username) {
    identity
    status
    properties {
      title
      type
      description
      priority
      timeBudget
      timeSpent
      project
      assignee
      dueDate
    }
    elementId
  }
}
`;
export const UPDATE_TASK_MUTATION = gql`
  mutation UpdateTask($identity: ID!, $input: TaskUpdateInput!) {
    updateTask(identity: $identity, input: $input) {
      identity
      properties {
        timeSpent
      }
    }
  }
`;
export const DELETE_TASK_MUTATION = gql`
  mutation DeleteTask($identity: ID!) {
    deleteTask(identity: $identity)
  }
`;
export const ADD_NOTE_MUTATION = gql`
  mutation AddNote(
    $title: String!
    $mapData: String!
    $linkedProject: String
    $linkedTaskId: String
    $username: String!
  ) {
    addNote(input: {
      title: $title
      mapData: $mapData
      linkedProject: $linkedProject
      linkedTaskId: $linkedTaskId
      username: $username
    }) {
      identity
      elementId
      properties {
        title
        mapData
        linkedProject
        username
        dateAdded
      }
    }
  }
`;
export const GET_NOTES_QUERY = gql`
  query GetNotes($username: String!, $linkedProject: String, $linkedTaskId: String) {
    getNotes(username: $username, linkedProject: $linkedProject, linkedTaskId: $linkedTaskId) {
      identity
      elementId
      properties {
        title
        mapData
        linkedProject
        username
        dateAdded
        dateLastModified
      }
    }
  }
`;

export const ADD_MEETING_WITH_CONTENT_MUTATION = gql`
  mutation AddMeetingWithContent($input: AddMeetingWithContentInput!) {
    addMeetingWithContent(input: $input) {
      meeting {
        identity
        properties {
          title
          type
        }
      }
      sentenceCount
      wordCount
      taskCount
    }
  }
`;

export const DELETE_MEETING_MUTATION = gql`
  mutation DeleteMeeting($identity: ID!) {
    deleteMeeting(identity: $identity)
  }
`;

export const ADD_MEETING_SENTENCE_MUTATION = gql`
  mutation AddMeetingSentence($input: AddMeetingSentenceInput!) {
    addMeetingSentence(input: $input) {
      source { id text lang }
      target { id text lang }
    }
  }
`;

export const ADD_MEETING_WORD_MUTATION = gql`
  mutation AddMeetingWord($input: AddMeetingWordInput!) {
    addMeetingWord(input: $input) {
      source { id text lang imageUrl imageDescription }
      target { id text lang }
    }
  }
`;

export const DELETE_MEETING_SENTENCE_MUTATION = gql`
  mutation DeleteMeetingSentence($sentenceId: ID!) {
    deleteMeetingSentence(sentenceId: $sentenceId)
  }
`;

export const DELETE_MEETING_WORD_MUTATION = gql`
  mutation DeleteMeetingWord($meetingId: ID!, $wordId: ID!) {
    deleteMeetingWord(meetingId: $meetingId, wordId: $wordId)
  }
`;

export const UPDATE_MEETING_DATE_MUTATION = gql`
  mutation UpdateMeetingDate($identity: ID!, $meetingDate: String!) {
    updateMeetingDate(identity: $identity, meetingDate: $meetingDate) {
      identity
      properties {
        title
        type
        meetingDate
        dateAdded
        dateLastModified
      }
    }
  }
`;

export const GET_MEETINGS_QUERY = gql`
  query GetMeetings($username: String!) {
    getMeetings(username: $username) {
      identity
      labels
      properties {
        title
        type
        description
        username
        meetingDate
        dateAdded
        dateLastModified
        lessonData
      }
      elementId
    }
  }
`;

export const RECORD_PRACTICE_MUTATION = gql`
  mutation RecordPractice($username: String!, $itemId: ID!, $itemType: String!, $isCorrect: Boolean!) {
    recordPractice(username: $username, itemId: $itemId, itemType: $itemType, isCorrect: $isCorrect) {
      timesPracticed
      timesCorrect
      lastPracticedAt
      nextReviewAt
      interval
    }
  }
`

export const GET_MEETING_WITH_CONTENT_QUERY = gql`
  query GetMeetingWithContent($identity: ID!) {
    getMeetingWithContent(identity: $identity) {
      meeting {
        identity
        labels
        properties {
          title
          type
          description
          username
          meetingDate
          dateAdded
          dateLastModified
          lessonData
        }
        elementId
      }
      sentences {
        source {
          id
          text
          lang
        }
        target {
          id
          text
          lang
        }
      }
      words {
        source {
          id
          text
          lang
          imageUrl
          imageDescription
        }
        target {
          id
          text
          lang
        }
      }
      tasks {
        id
        title
        type
        description
        priority
      }
    }
  }
`;

export const ADD_PARAGRAPH_WITH_CONTENT_MUTATION = gql`
  mutation AddParagraphWithContent($input: AddParagraphWithContentInput!) {
    addParagraphWithContent(input: $input) {
      paragraph {
        identity
        properties {
          title
          text
          lang
          posMap
        }
      }
      sentenceCount
      wordCount
    }
  }
`;

export const GET_PARAGRAPHS_QUERY = gql`
  query GetParagraphs($username: String!, $lang: String) {
    getParagraphs(username: $username, lang: $lang) {
      identity
      labels
      properties {
        title
        text
        lang
        posMap
        username
        dateAdded
        dateLastModified
      }
      elementId
    }
  }
`;

export const GET_PARAGRAPH_WITH_CONTENT_QUERY = gql`
  query GetParagraphWithContent($identity: ID!, $username: String) {
    getParagraphWithContent(identity: $identity, username: $username) {
      paragraph {
        identity
        labels
        properties {
          title
          text
          lang
          posMap
          username
          dateAdded
          dateLastModified
        }
        elementId
      }
      sentences {
        source {
          id
          text
          lang
          order
        }
        target {
          id
          text
          lang
        }
      }
      words {
        source {
          id
          text
          lang
          timesPracticed
          timesCorrect
          lastPracticedAt
          imageUrl
          imageDescription
        }
        target {
          id
          text
          lang
        }
      }
    }
  }
`;

export const DELETE_PARAGRAPH_MUTATION = gql`
  mutation DeleteParagraph($identity: ID!) {
    deleteParagraph(identity: $identity)
  }
`;

export const ADD_PARAGRAPH_WORD_LOOKUP_MUTATION = gql`
  mutation AddParagraphWordLookup(
    $username: String!
    $paragraphId: ID!
    $word: String!
    $translation: String!
    $lang: String!
  ) {
    addParagraphWordLookup(
      username: $username
      paragraphId: $paragraphId
      word: $word
      translation: $translation
      lang: $lang
    ) {
      id
      text
      lang
    }
  }
`;
// ─── Media ────────────────────────────────────────────────────────────
// Persistent project store for the media workflow. The Mac mini owns
// the filesystem; this module owns the Neo4j metadata + check-out registry.

export const LIST_SHOOTS_QUERY = gql`
  query ListShoots($project: String) {
    listShoots(project: $project) {
      identity
      properties {
        name
        slug
        project
        projectSlug
        notes
        shootDate
        username
        createdAt
        dateLastModified
        visibility
        checkedOutBy
        checkedOutAt
        assetCount
      }
    }
  }
`;

export const GET_SHOOT_QUERY = gql`
  query GetShoot($identity: ID!) {
    getShoot(identity: $identity) {
      shoot {
        identity
        properties {
          name
          slug
          project
          projectSlug
          notes
          shootDate
          username
          createdAt
          dateLastModified
          visibility
          checkedOutBy
          checkedOutAt
          assetCount
        }
      }
      assets {
        identity
        path
        filename
        date
        device
        kind
        size
        mtime
        thumbnailUrl
        fileUrl
        downloadUrl
        visibility
        uploadedBy
        hash
        sidecars { path filename kind size downloadUrl }
      }
    }
  }
`;

// Signed URLs for every original in a shoot, for pulling it to a local drive.
export const GET_SHOOT_DOWNLOAD_QUERY = gql`
  query GetShootDownload($identity: ID!) {
    getShootDownload(identity: $identity) {
      shoot
      fileCount
      totalBytes
      expiresAt
      files { url output filename size }
    }
  }
`;


// ─── Deliveries ──────────────────────────────────────────────────────────────
// A fixed set of finished files handed to a client. Lives in
// deliveries/<project>/<delivery>/ and is what an external login will see.
//
// Written out in full rather than composed from shared fragments: the query
// validator parses these files statically, so an interpolated \${...} would
// make them unparseable and therefore unchecked.

export const LIST_DELIVERIES_QUERY = gql`
  query ListDeliveries($project: String) {
    listDeliveries(project: $project) {
      identity
      properties {
      name
      slug
      project
      projectSlug
      deliveredOn
      notes
      username
      createdAt
      dateLastModified
      visibility
      path
      fileCount
      totalBytes
      }
    }
  }
`;

export const GET_DELIVERY_QUERY = gql`
  query GetDelivery($identity: ID!) {
    getDelivery(identity: $identity) {
      delivery {
        identity
        properties {
        name
        slug
        project
        projectSlug
        deliveredOn
        notes
        username
        createdAt
        dateLastModified
        visibility
        path
        fileCount
        totalBytes
        }
      }
    files {
      identity
      path
      filename
      kind
      size
      mtime
      thumbnailUrl
      fileUrl
      downloadUrl
    }
    }
  }
`;

export const CREATE_DELIVERY_MUTATION = gql`
  mutation CreateDelivery($input: CreateDeliveryInput!) {
    createDelivery(input: $input) {
      identity
      properties {
      name
      slug
      project
      projectSlug
      deliveredOn
      notes
      username
      createdAt
      dateLastModified
      visibility
      path
      fileCount
      totalBytes
      }
    }
  }
`;

// Rescan the folder after uploading, and link each export to its original.
export const INDEX_DELIVERY_MUTATION = gql`
  mutation IndexDelivery($identity: ID!) {
    indexDelivery(identity: $identity) {
      delivery {
        identity
        properties {
        name
        slug
        project
        projectSlug
        deliveredOn
        notes
        username
        createdAt
        dateLastModified
        visibility
        path
        fileCount
        totalBytes
        }
      }
    files {
      identity
      path
      filename
      kind
      size
      mtime
      thumbnailUrl
      fileUrl
      downloadUrl
    }
    }
  }
`;

export const SET_DELIVERY_VISIBILITY_MUTATION = gql`
  mutation SetDeliveryVisibility($identity: ID!, $visibility: String!) {
    setDeliveryVisibility(identity: $identity, visibility: $visibility) {
      identity
      properties {
      name
      slug
      project
      projectSlug
      deliveredOn
      notes
      username
      createdAt
      dateLastModified
      visibility
      path
      fileCount
      totalBytes
      }
    }
  }
`;

export const DELETE_DELIVERY_MUTATION = gql`
  mutation DeleteDelivery($identity: ID!) {
    deleteDelivery(identity: $identity)
  }
`;

export const GET_DELIVERY_DOWNLOAD_QUERY = gql`
  query GetDeliveryDownload($identity: ID!) {
    getDeliveryDownload(identity: $identity) {
      shoot
      fileCount
      totalBytes
      expiresAt
      files { url output filename size }
    }
  }
`;

export const CREATE_SHOOT_MUTATION = gql`
  mutation CreateShoot($input: CreateShootInput!) {
    createShoot(input: $input) {
      identity
      properties { name slug project shootDate visibility }
    }
  }
`;

export const ADD_ASSETS_TO_SHOOT_MUTATION = gql`
  mutation AddAssetsToShoot($identity: ID!, $paths: [String!]!) {
    addAssetsToShoot(identity: $identity, paths: $paths)
  }
`;

export const REMOVE_ASSET_FROM_SHOOT_MUTATION = gql`
  mutation RemoveAssetFromShoot($identity: ID!, $path: String!) {
    removeAssetFromShoot(identity: $identity, path: $path)
  }
`;

export const UPDATE_SHOOT_DATE_MUTATION = gql`
  mutation UpdateShootDate($identity: ID!, $shootDate: String!) {
    updateShootDate(identity: $identity, shootDate: $shootDate) {
      identity
      properties { shootDate dateLastModified }
    }
  }
`;

export const SET_SHOOT_VISIBILITY_MUTATION = gql`
  mutation SetShootVisibility($identity: ID!, $visibility: String!) {
    setShootVisibility(identity: $identity, visibility: $visibility) {
      identity
      properties { visibility }
    }
  }
`;

export const CHECK_OUT_SHOOT_MUTATION = gql`
  mutation CheckOutShoot($identity: ID!) {
    checkOutShoot(identity: $identity) {
      identity
      properties { checkedOutBy checkedOutAt }
    }
  }
`;

export const CHECK_IN_SHOOT_MUTATION = gql`
  mutation CheckInShoot($identity: ID!) {
    checkInShoot(identity: $identity) {
      identity
      properties { checkedOutBy checkedOutAt }
    }
  }
`;

export const DELETE_SHOOT_MUTATION = gql`
  mutation DeleteShoot($identity: ID!) {
    deleteShoot(identity: $identity)
  }
`;

export const GET_MEDIA_LIBRARY_QUERY = gql`
  query GetMediaLibrary($username: String, $limit: Int, $cursor: String) {
    getMediaLibrary(username: $username, limit: $limit, cursor: $cursor) {
      nextCursor
      totalDays
      totalAssets
      returnedAssets
      days {
        date
        devices {
          device
          assets {
            identity
            path
            filename
            date
            device
            kind
            size
            mtime
            thumbnailUrl
            fileUrl
            downloadUrl
            visibility
            uploadedBy
            hash
            sidecars { path filename kind size downloadUrl }
            projects
          }
        }
      }
    }
  }
`;

// Signed URLs for an arbitrary selection out of the library, valid 12h rather
// than the 30 minutes a browsing URL carries. Sidecars of the chosen files come
// too -- the server adds them, since the grid nests them under their parent and
// never offers them for selection.
export const GET_SELECTION_DOWNLOAD_QUERY = gql`
  query GetSelectionDownload($paths: [String!]!) {
    getSelectionDownload(paths: $paths) {
      shoot
      fileCount
      totalBytes
      expiresAt
      files { url output filename size }
    }
  }
`;

export const ATTACH_MEDIA_ASSETS_MUTATION = gql`
  mutation AttachMediaAssets($paths: [String!]!, $project: String!, $username: String!) {
    attachMediaAssetsToProject(paths: $paths, project: $project, username: $username)
  }
`;

export const ATTACH_TASK_OUTPUTS_MUTATION = gql`
  mutation AttachTaskOutputs($taskId: ID!, $paths: [String!]!, $username: String!) {
    attachTaskOutputs(taskId: $taskId, paths: $paths, username: $username)
  }
`;

export const DETACH_TASK_OUTPUT_MUTATION = gql`
  mutation DetachTaskOutput($taskId: ID!, $path: String!) {
    detachTaskOutput(taskId: $taskId, path: $path)
  }
`;

export const GET_TASK_OUTPUTS_QUERY = gql`
  query GetTaskOutputs($taskId: ID!) {
    getTaskOutputs(taskId: $taskId) {
      identity
      path
      filename
      kind
      thumbnailUrl
    }
  }
`;

export const GET_TASKS_FOR_MEDIA_PATHS_QUERY = gql`
  query GetTasksForMediaPaths($paths: [String!]!) {
    getTasksForMediaPaths(paths: $paths) {
      path
      tasks { id title }
    }
  }
`;

export const DETACH_MEDIA_ASSET_MUTATION = gql`
  mutation DetachMediaAsset($path: String!, $project: String!) {
    detachMediaAssetFromProject(path: $path, project: $project)
  }
`;

// Who the stored token says we are. The username lives in React state and is
// lost on refresh while the token survives in localStorage, so this is how the
// UI recovers identity instead of appearing logged out.
export const ME_QUERY = gql`
  query Me {
    me {
      id
      username
      role
    }
  }
`;

// Permission to upload into one folder, valid 15 minutes. Ask for this
// immediately before uploading, then POST the files to the returned url.
// Replaces the shared token that used to ship in the bundle.
export const CREATE_UPLOAD_GRANT_MUTATION = gql`
  mutation CreateUploadGrant($path: String!) {
    createUploadGrant(path: $path) {
      url
      path
      expiresAt
    }
  }
`;

export const SET_MEDIA_ASSET_VISIBILITY_MUTATION = gql`
  mutation SetMediaAssetVisibility($paths: [String!]!, $visibility: String!) {
    setMediaAssetVisibility(paths: $paths, visibility: $visibility)
  }
`;

// ─── Task groups ─────────────────────────────────────────────────────────────

export const ADD_TASK_GROUP_WITH_TASKS_MUTATION = gql`
  mutation AddTaskGroupWithTasks($input: AddTaskGroupWithTasksInput!) {
    addTaskGroupWithTasks(input: $input) {
      group {
        identity
        properties { title project }
      }
      tasks {
        identity
        properties { title type assignee priority }
      }
    }
  }
`;

// ─── Journal ─────────────────────────────────────────────────────────────────

export const GET_JOURNAL_ENTRIES_QUERY = gql`
  query GetJournalEntries($username: String!, $tag: String, $from: String, $to: String, $includeArchived: Boolean, $limit: Int) {
    getJournalEntries(username: $username, tag: $tag, from: $from, to: $to, includeArchived: $includeArchived, limit: $limit) {
      identity
      properties {
        username
        body
        title
        mood
        tags
        source
        archived
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_REFLECTIONS_QUERY = gql`
  query GetReflections($username: String!, $linkedEntryId: ID, $limit: Int) {
    getReflections(username: $username, linkedEntryId: $linkedEntryId, limit: $limit) {
      identity
      properties {
        username
        text
        model
        mode
        createdAt
      }
    }
  }
`;

export const ADD_JOURNAL_ENTRY_MUTATION = gql`
  mutation AddJournalEntry($input: JournalEntryInput!) {
    addJournalEntry(input: $input) {
      identity
      properties {
        username
        body
        title
        mood
        tags
        source
        archived
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_JOURNAL_ENTRY_MUTATION = gql`
  mutation UpdateJournalEntry($identity: ID!, $input: JournalEntryUpdateInput!) {
    updateJournalEntry(identity: $identity, input: $input) {
      identity
      properties {
        body
        title
        mood
        tags
        archived
        updatedAt
      }
    }
  }
`;

export const DELETE_JOURNAL_ENTRY_MUTATION = gql`
  mutation DeleteJournalEntry($identity: ID!) {
    deleteJournalEntry(identity: $identity)
  }
`;

export const ADD_REFLECTION_MUTATION = gql`
  mutation AddReflection($input: ReflectionInput!) {
    addReflection(input: $input) {
      identity
      properties {
        username
        text
        model
        mode
        createdAt
      }
    }
  }
`;

export const DELETE_REFLECTION_MUTATION = gql`
  mutation DeleteReflection($identity: ID!) {
    deleteReflection(identity: $identity)
  }
`;

// ─── Client access ───────────────────────────────────────────────────────────
// A client account sees only the deliveries marked 'client' in the projects it
// has been granted. Everything else in the media layer refuses it outright.

export const MY_ACCESS_QUERY = gql`
  query MyAccess {
    myAccess {
      username
      role
      projects {
        username
        project
        canSeeOriginals
        grantedBy
        grantedAt
      }
    }
  }
`;

export const MY_DELIVERIES_QUERY = gql`
  query MyDeliveries {
    myDeliveries {
      identity
      properties {
        name
        slug
        project
        projectSlug
        deliveredOn
        notes
        username
        createdAt
        dateLastModified
        visibility
        path
        fileCount
        totalBytes
      }
    }
  }
`;

export const LIST_PROJECT_ACCESS_QUERY = gql`
  query ListProjectAccess($project: String!) {
    listProjectAccess(project: $project) {
      username
      project
      canSeeOriginals
      grantedBy
      grantedAt
    }
  }
`;

export const CREATE_CLIENT_ACCOUNT_MUTATION = gql`
  mutation CreateClientAccount($username: String!, $password: String!, $project: String!, $canSeeOriginals: Boolean) {
    createClientAccount(username: $username, password: $password, project: $project, canSeeOriginals: $canSeeOriginals) {
      id
      username
      role
    }
  }
`;

export const GRANT_PROJECT_ACCESS_MUTATION = gql`
  mutation GrantProjectAccess($username: String!, $project: String!, $canSeeOriginals: Boolean) {
    grantProjectAccess(username: $username, project: $project, canSeeOriginals: $canSeeOriginals) {
      username
      project
      canSeeOriginals
    }
  }
`;

export const REVOKE_PROJECT_ACCESS_MUTATION = gql`
  mutation RevokeProjectAccess($username: String!, $project: String!) {
    revokeProjectAccess(username: $username, project: $project)
  }
`;

export const SET_CLIENT_PASSWORD_MUTATION = gql`
  mutation SetClientPassword($username: String!, $password: String!) {
    setClientPassword(username: $username, password: $password)
  }
`;

// ── Learner profile (user node + native / learning languages) ────────────────
const USER_PROFILE_FIELDS = `
  user { id username role name gender birthYear occupation homeCity homeCountry profile }
  native { code name }
  learning { code name level startedAt active }
`;

export const GET_USER_PROFILE_QUERY = gql`
  query GetUserProfile($username: String!) {
    getUserProfile(username: $username) { ${USER_PROFILE_FIELDS} }
  }
`;

export const UPDATE_USER_PROFILE_MUTATION = gql`
  mutation UpdateUserProfile($username: String!, $input: UserProfileInput!) {
    updateUserProfile(username: $username, input: $input) { ${USER_PROFILE_FIELDS} }
  }
`;

export const SET_NATIVE_LANGUAGES_MUTATION = gql`
  mutation SetNativeLanguages($username: String!, $languages: [LanguageInput!]!) {
    setNativeLanguages(username: $username, languages: $languages) { ${USER_PROFILE_FIELDS} }
  }
`;

export const SET_LEARNING_LANGUAGE_MUTATION = gql`
  mutation SetLearningLanguage($username: String!, $code: String!, $name: String, $level: String) {
    setLearningLanguage(username: $username, code: $code, name: $name, level: $level) { ${USER_PROFILE_FIELDS} }
  }
`;

export const REMOVE_LEARNING_LANGUAGE_MUTATION = gql`
  mutation RemoveLearningLanguage($username: String!, $code: String!) {
    removeLearningLanguage(username: $username, code: $code) { ${USER_PROFILE_FIELDS} }
  }
`;

// ── Spaced-repetition read side: items due for review ────────────────────────
export const GET_DUE_ITEMS_QUERY = gql`
  query GetDueItems($username: String!, $lang: String, $limit: Int) {
    getDueItems(username: $username, lang: $lang, limit: $limit) {
      id text lang itemType
      translationId translationText translationLang
      timesPracticed timesCorrect nextReviewAt
    }
  }
`;

// ── Language "tech tree": topics, prerequisites, per-user completion ──────────
export const GET_LANGUAGE_TREE_QUERY = gql`
  query GetLanguageTree($username: String!, $langCode: String!) {
    getLanguageTree(username: $username, langCode: $langCode) {
      id slug title level order blurb requires completed lessonMeetingId
    }
  }
`;

export const SEED_CURRICULUM_MUTATION = gql`
  mutation SeedCurriculum($langCode: String!, $name: String, $topics: [TopicSeedInput!]!) {
    seedCurriculum(langCode: $langCode, name: $name, topics: $topics)
  }
`;

export const COMPLETE_TOPIC_MUTATION = gql`
  mutation CompleteTopic($username: String!, $topicId: ID!) {
    completeTopic(username: $username, topicId: $topicId)
  }
`;

export const ATTACH_LESSON_TO_TOPIC_MUTATION = gql`
  mutation AttachLessonToTopic($topicId: ID!, $meetingId: ID!) {
    attachLessonToTopic(topicId: $topicId, meetingId: $meetingId)
  }
`;

// ── Homework: assign lessons, speaking answers (speech-to-text), teacher review ──
const SUBMISSION_FIELDS = `id answers { index prompt text } submittedAt updatedAt comment reviewedAt`

export const MY_ASSIGNMENTS_QUERY = gql`
  query MyAssignments($username: String!) {
    myAssignments(username: $username) {
      meetingId title teacher student assignedAt due status
      submission { ${SUBMISSION_FIELDS} }
    }
  }
`

export const MY_ASSIGNED_LESSONS_QUERY = gql`
  query MyAssignedLessons($username: String!) {
    myAssignedLessons(username: $username) {
      meetingId title due
      students { student assignedAt due status submission { ${SUBMISSION_FIELDS} } }
    }
  }
`

export const MY_SUBMISSION_QUERY = gql`
  query MySubmission($username: String!, $meetingId: ID!) {
    mySubmission(username: $username, meetingId: $meetingId) { ${SUBMISSION_FIELDS} }
  }
`

export const SEARCH_USERS_QUERY = gql`
  query SearchUsers($q: String!, $limit: Int) {
    searchUsers(q: $q, limit: $limit)
  }
`

export const ASSIGN_LESSON_MUTATION = gql`
  mutation AssignLesson($username: String!, $meetingId: ID!, $students: [String!]!, $due: String) {
    assignLesson(username: $username, meetingId: $meetingId, students: $students, due: $due)
  }
`

export const UNASSIGN_LESSON_MUTATION = gql`
  mutation UnassignLesson($username: String!, $meetingId: ID!, $student: String!) {
    unassignLesson(username: $username, meetingId: $meetingId, student: $student)
  }
`

export const SUBMIT_SPEAKING_ANSWERS_MUTATION = gql`
  mutation SubmitSpeakingAnswers($username: String!, $meetingId: ID!, $answers: [SpeakingAnswerInput!]!) {
    submitSpeakingAnswers(username: $username, meetingId: $meetingId, answers: $answers) { ${SUBMISSION_FIELDS} }
  }
`

export const REVIEW_SUBMISSION_MUTATION = gql`
  mutation ReviewSubmission($username: String!, $submissionId: ID!, $comment: String!) {
    reviewSubmission(username: $username, submissionId: $submissionId, comment: $comment) { id comment reviewedAt }
  }
`

// ── Sharing a finished practice set with a teacher ──────────────────────────
const DRILL_RESULT_FIELDS = `id student teacher title language mode total perfect pct details sharedAt comment reviewedAt`

export const MY_TEACHERS_QUERY = gql`
  query MyTeachers($username: String!) { myTeachers(username: $username) }
`

export const DRILL_RESULTS_FOR_ME_QUERY = gql`
  query DrillResultsForMe($username: String!, $limit: Int) {
    drillResultsForMe(username: $username, limit: $limit) { ${DRILL_RESULT_FIELDS} }
  }
`

export const MY_SHARED_RESULTS_QUERY = gql`
  query MySharedResults($username: String!, $limit: Int) {
    mySharedResults(username: $username, limit: $limit) { ${DRILL_RESULT_FIELDS} }
  }
`

export const SHARE_DRILL_RESULT_MUTATION = gql`
  mutation ShareDrillResult($username: String!, $teacher: String!, $input: DrillResultInput!) {
    shareDrillResult(username: $username, teacher: $teacher, input: $input) { ${DRILL_RESULT_FIELDS} }
  }
`

export const COMMENT_DRILL_RESULT_MUTATION = gql`
  mutation CommentDrillResult($username: String!, $resultId: ID!, $comment: String!) {
    commentDrillResult(username: $username, resultId: $resultId, comment: $comment) { id comment reviewedAt }
  }
`
